"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _fileSaver = _interopRequireDefault(require("file-saver"));

var _AccentButton = _interopRequireDefault(require("../Button/AccentButton"));

var _SquareBorderButton = _interopRequireDefault(require("../Button/SquareBorderButton"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _HoverAccentButton = _interopRequireDefault(require("../Button/HoverAccentButton"));

var _Confirmation = _interopRequireDefault(require("../Confirmation"));

var s = _interopRequireWildcard(require("./Upload.style"));

var _class, _temp;

var Upload = (0, _emotionTheming.withTheme)(_class = (_temp =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Upload, _React$Component);

  function Upload(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Upload);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Upload).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onDownload",
    /*#__PURE__*/
    (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    _regenerator.default.mark(function _callee() {
      var _this$props, downloadUrl, fileName, onBeforeDownload, response, blobResponse;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, downloadUrl = _this$props.downloadUrl, fileName = _this$props.fileName, onBeforeDownload = _this$props.onBeforeDownload;
              _context.next = 3;
              return fetch(downloadUrl);

            case 3:
              response = _context.sent;
              _context.next = 6;
              return response.blob();

            case 6:
              blobResponse = _context.sent;

              if (onBeforeDownload) {
                onBeforeDownload(blobResponse, fileName, function (newBlobResponse, newFileName) {
                  _fileSaver.default.saveAs(newBlobResponse, newFileName);
                });
              } else {
                _fileSaver.default.saveAs(blobResponse, fileName);
              }

              _this.props.onDownload();

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "uploadClickHandler", function () {
      document.getElementById('fileToUpload').click();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "deleteUploadHandler", function () {
      _this.setState({
        uploading: false
      });

      _this.props.onDeleteUpload();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "cancelUploadHandler", function () {
      _this.setState({
        uploading: false
      });

      _this.props.onCancelUpload();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onChangeHandler", function (e) {
      _this.props.onChange(e);

      _this.setState({
        uploading: true
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onCancelUploadClick", function () {
      _this.setState({
        uploading: false
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "onLinkClick", function (e) {
      e.stopPropagation();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "renderUploadButton", function () {
      return _this.props.darkTheme ? _react.default.createElement("div", {
        className: s.darkUploadButton,
        role: "button",
        tabIndex: "0",
        onClick: _this.uploadClickHandler
      }, _react.default.createElement(_Icon.default, {
        className: "upload-icon",
        type: "file"
      }), _react.default.createElement("span", {
        className: "upload-text"
      }, "Upload file")) : _react.default.createElement("div", {
        className: s.buttonWrapper
      }, _react.default.createElement(_SquareBorderButton.default, {
        text: "Upload File",
        icon: {
          type: 'upload',
          style: {
            width: '18px',
            marginRight: '6px'
          }
        },
        onClick: _this.uploadClickHandler,
        type: "filled"
      }));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "renderPreview", function () {
      var _this$props2 = _this.props,
          theme = _this$props2.theme,
          fileName = _this$props2.fileName,
          fileSize = _this$props2.fileSize,
          showDelete = _this$props2.showDelete,
          darkTheme = _this$props2.darkTheme,
          className = _this$props2.className;
      return _react.default.createElement("div", {
        className: (0, _classnames.default)(s.root, darkTheme ? s.darkThemeRoot : '', className)
      }, _react.default.createElement("div", {
        className: (0, _classnames.default)(s.rowClass, 'preview')
      }, _react.default.createElement(_Icon.default, {
        className: "file-icon",
        type: "file",
        style: {
          marginLeft: '20px'
        }
      }), _react.default.createElement("div", {
        className: (0, _classnames.default)(s.colClass, 'file-info')
      }, _react.default.createElement("p", {
        className: (0, _classnames.default)(s.fileNameClass(theme), 'file-name')
      }, fileName), _react.default.createElement("p", {
        className: (0, _classnames.default)(s.fileSizeClass(theme), 'file-size')
      }, fileSize, " FILE ATTACHED")), _react.default.createElement("div", {
        className: s.actionButtonsWrapperClass
      }, _react.default.createElement(_AccentButton.default, {
        onClick: _this.onDownload,
        className: "action-button",
        icon: {
          type: 'download',
          style: {
            width: '20px',
            height: '20px'
          }
        },
        style: {
          marginRight: '26px',
          width: '20px'
        }
      }), showDelete && _react.default.createElement(_HoverAccentButton.default, {
        onClick: _this.deleteUploadHandler,
        className: "action-button",
        icon: {
          type: 'delete',
          style: {
            width: '20px',
            height: '20px'
          }
        },
        style: {
          width: '20px',
          height: '20px'
        }
      }))));
    });
    _this.state = {
      uploading: false
    };
    return _this;
  }

  (0, _createClass2.default)(Upload, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          progress = _this$props3.progress,
          dropdownPlacement = _this$props3.dropdownPlacement,
          showPreview = _this$props3.showPreview,
          fileName = _this$props3.fileName,
          theme = _this$props3.theme,
          hideCancelButton = _this$props3.hideCancelButton,
          darkTheme = _this$props3.darkTheme,
          className = _this$props3.className,
          inputProps = _this$props3.inputProps;
      var uploading = this.state.uploading;

      if (showPreview) {
        return this.renderPreview();
      }

      return _react.default.createElement("div", {
        className: (0, _classnames.default)(s.root, darkTheme ? s.darkThemeRoot : '', className)
      }, !uploading && _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("div", {
        style: {
          display: 'none',
          hover: 'none'
        }
      }, _react.default.createElement("input", (0, _extends2.default)({
        type: "file",
        name: "fileToUpload",
        id: "fileToUpload",
        onChange: this.onChangeHandler
      }, inputProps))), this.renderUploadButton()), uploading && progress < 100 && _react.default.createElement("div", {
        className: (0, _classnames.default)(s.rowClass, 'uploadContainer')
      }, _react.default.createElement(_Icon.default, {
        className: "file-icon",
        type: "file",
        style: {
          marginLeft: '20px'
        }
      }), _react.default.createElement("div", {
        className: (0, _classnames.default)(s.colClass, 'upload-col')
      }, _react.default.createElement("p", {
        className: (0, _classnames.default)(s.fileNameClass(theme), 'file-name')
      }, fileName), _react.default.createElement("div", {
        className: (0, _classnames.default)(s.row, 'upload-row')
      }, _react.default.createElement("div", {
        className: (0, _classnames.default)(s.uploadBarWrapper(theme), 'upload-bar')
      }, _react.default.createElement("div", {
        className: (0, _classnames.default)(s.progressClass("".concat(progress, "%"), theme), 'upload-progress')
      })), _react.default.createElement("div", {
        className: (0, _classnames.default)(s.fontStyleClass, 'upload-progress-title')
      }, "".concat(progress, "%")))), !hideCancelButton && _react.default.createElement("div", {
        className: (0, _classnames.default)(s.rowReverseClass, 'upload-row-reverse')
      }, _react.default.createElement(_Confirmation.default, {
        onConfirm: this.cancelUploadHandler,
        title: "Cancel upload?",
        message: "Are you sure you want to Cancel uploading ".concat(fileName, "?"),
        dropdownPlacement: dropdownPlacement
      }, _react.default.createElement(_HoverAccentButton.default, {
        icon: {
          type: 'close',
          style: {
            width: '16px',
            height: '16px'
          }
        },
        className: "action-button"
      })))), uploading && progress === 100 && this.renderPreview());
    }
  }]);
  return Upload;
}(_react.default.Component), _temp)) || _class;

Upload.propTypes = {
  onChange: _propTypes.default.func,
  progress: _propTypes.default.number,
  onBeforeDownload: _propTypes.default.func,
  onDownload: _propTypes.default.func,
  onCancelUpload: _propTypes.default.func,
  onDeleteUpload: _propTypes.default.func,
  hideCancelButton: _propTypes.default.bool,
  downloadUrl: _propTypes.default.string,
  dropdownPlacement: _propTypes.default.string,
  showDelete: _propTypes.default.bool,
  fileName: _propTypes.default.string,
  fileSize: _propTypes.default.string,
  darkTheme: _propTypes.default.bool,
  className: _propTypes.default.string
};
Upload.defaultProps = {
  onChange: function onChange() {},
  progress: 0,
  onBeforeDownload: null,
  onDownload: function onDownload() {},
  onCancelUpload: function onCancelUpload() {},
  onDeleteUpload: function onDeleteUpload() {},
  hideCancelButton: false,
  downloadUrl: '',
  dropdownPlacement: 'bottomRight',
  showDelete: true,
  fileName: 'Untitled',
  fileSize: '',
  darkTheme: false,
  className: ''
};
var _default = Upload;
exports.default = _default;